import { AllocationViewActionIdentifierModel } from '../../models';

export class AllocationViewCallToSecurityCheckAction {
  public static readonly type = '[AllocationViewCallToSecurityCheckAction] Call To Security Check';

  constructor(
    public payload: {
      identifier: AllocationViewActionIdentifierModel;
    },
  ) {}
}

export class AllocationViewCallToSecurityCheckActionSetInitialState {
  public static readonly type = '[AllocationViewCallToSecurityCheckAction] Set Initial State';
}
